import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AttendanceScreen from './components/AttendanceScreen';
import AttendanceHistoryScreen from './components/AttendanceHistoryScreen';
import SettingsScreen from './components/SettingsScreen';
import LivenessTestScreen from './components/LivenessTestScreen';
import TestLivenessScreen from './components/TestLivenessScreen';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<AttendanceScreen />} />
          <Route path="/history" element={<AttendanceHistoryScreen />} />
          <Route path="/settings" element={<SettingsScreen />} />
          <Route path="/liveness-test" element={<LivenessTestScreen />} />
          <Route path="/test" element={<TestLivenessScreen />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 